import ClientModule from './client/Module'
import LocaleModule from './locale/Module'
import TimelineModule from './timeline/Module'
import ImagesModule from './images/Module'
import VideosModule from './videos/Module'
import ViewportModule from './viewport/Module'
import DevLog from './devlog/Module'
import ModalModule from './modal/Module'
import PreviewModule from './preview/Module'
import ThemeModule from './theme/Module'
import ThemeEditorModule from './theme_editor/Module'
import HooksModule from './hooks/Module'
import WebcamModule from './webcam/Module'
import SurveyLogModule from './survey_log/Module'
import SupervisorModule from './supervisor/Module'
import VoidModule from './void/Module'
import ToolbarModule from './toolbar/Module'
import MouseLogModule from './mouselog/Module'
import { IModule, ModuleID } from './types'

export const REGISTERED_MODULES: Record<ModuleID, IModule> = {
  [ModuleID.CLIENT]: ClientModule,
  [ModuleID.LOCALE]: LocaleModule,
  [ModuleID.TIMELINE]: TimelineModule,
  [ModuleID.IMAGES]: ImagesModule,
  [ModuleID.VIDEOS]: VideosModule,
  [ModuleID.VIEWPORT]: ViewportModule,
  [ModuleID.WEBCAM]: WebcamModule,
  [ModuleID.DEV_LOG]: DevLog,
  [ModuleID.MODAL]: ModalModule,
  [ModuleID.PREVIEW]: PreviewModule,
  [ModuleID.THEME]: ThemeModule,
  [ModuleID.MOUSE_LOG]: MouseLogModule,
  [ModuleID.THEME_EDITOR]: ThemeEditorModule,
  [ModuleID.HOOKS]: HooksModule,
  [ModuleID.SURVEY_LOG]: SurveyLogModule,
  [ModuleID.SUPERVISOR]: SupervisorModule,
  [ModuleID.VOID]: VoidModule,
  [ModuleID.TOOLBAR]: ToolbarModule
}

export const DEFAULT_MODULES_TO_LOAD: ModuleID[] = [
  ModuleID.DEV_LOG,
  ModuleID.CLIENT,
  ModuleID.LOCALE,
  ModuleID.TIMELINE,
  ModuleID.IMAGES,
  ModuleID.VIDEOS,
  ModuleID.WEBCAM,
  ModuleID.VIEWPORT,
  ModuleID.THEME,
  ModuleID.DEV_LOG,
  ModuleID.MOUSE_LOG,
  ModuleID.SURVEY_LOG,
  ModuleID.SUPERVISOR
]
